/* ═══════════════════════════════════════════════════════
   The Builder PDP — builder-pdp.js
   Arc Dept. | Worn Collection
   ═══════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── State ─────────────────────────────────────────── */
  const state = {
    aesthetic:  null,   // e.g. "clean-boy"
    aestheticName: null, // e.g. "Clean Boy"
    metal:      null,   // "gold" | "silver"
    chains:     0,
    rings:      0,
    bracelets:  0,
    ringSize:   null,   // "S" | "M" | "L"
    pricePerPiece: 20,
  };

  /* ── Cache DOM ─────────────────────────────────────── */
  const $ = (sel) => document.querySelector(sel);
  const $$ = (sel) => [...document.querySelectorAll(sel)];

  // Qty displays
  const qtyDisplay = {
    chain:    $('#bl-qty-chain'),
    ring:     $('#bl-qty-ring'),
    bracelet: $('#bl-qty-bracelet'),
  };

  // Qty buttons
  const minusBtns = $$('.bl-qty-btn--minus');
  const plusBtns  = $$('.bl-qty-btn--plus');

  // Preview panel
  const elCountChains    = $('#bl-count-chains');
  const elPriceChains    = $('#bl-price-chains');
  const elCountRings     = $('#bl-count-rings');
  const elPriceRings     = $('#bl-price-rings');
  const elCountBracelets = $('#bl-count-bracelets');
  const elPriceBracelets = $('#bl-price-bracelets');
  const elTotalFinal     = $('#bl-total-final');
  const elPreviewMinNote = $('#bl-preview-min-note');

  // Progress
  const progressFill = $('#bl-progress-fill');

  // Section confirms
  const elStyleConfirm = $('#bl-style-confirm');
  const elMetalConfirm = $('#bl-metal-confirm');

  // Ring size section
  const ringSizeSection = $('#bl-ring-size');

  // ATC form
  const atcBtn         = $('#bl-atc-btn');
  const addForm        = $('#bl-add-form');
  const inputQuantity  = $('#bl-quantity');
  const inputAesthetic = $('#bl-prop-aesthetic');
  const inputMetal     = $('#bl-prop-metal');
  const inputChains    = $('#bl-prop-chains');
  const inputRings     = $('#bl-prop-rings');
  const inputBracelets = $('#bl-prop-bracelets');
  const inputSize      = $('#bl-prop-size');

  // Purchase summary
  const selStyle     = $('#bl-sel-style');
  const selMetal     = $('#bl-sel-metal');
  const selChains    = $('#bl-sel-chains');
  const selRings     = $('#bl-sel-rings');
  const selBracelets = $('#bl-sel-bracelets');
  const selSizeRow   = $('#bl-sel-size-row');
  const selSize      = $('#bl-sel-size');

  // Purchase price
  const purchasePrice    = $('#bl-purchase-price');
  const purchasePriceSub = $('#bl-purchase-price-sub');

  // Sticky
  const stickyBar    = $('#bl-sticky');
  const stickyLabel  = $('#bl-sticky-label');
  const stickyPrice  = $('#bl-sticky-price');
  const stickyBtn    = $('#bl-sticky-btn');

  /* ── Read price_per_piece from DOM ─────────────────── */
  const ppEl = $('[data-price-per-piece]');
  if (ppEl) state.pricePerPiece = parseInt(ppEl.dataset.pricePerPiece, 10) || 20;
  // Fallback: read from preview __per-piece text
  const ppText = $('.bl-preview__per-piece');
  if (ppText) {
    const match = ppText.textContent.match(/\$?(\d+)/);
    if (match) state.pricePerPiece = parseInt(match[1], 10);
  }

  /* ── Helpers ───────────────────────────────────────── */
  const fmt = (n) => '$' + (n * state.pricePerPiece).toString();

  function total() {
    return state.chains + state.rings + state.bracelets;
  }

  /* ── Update all UI from state ──────────────────────── */
  function render() {
    updateQtyDisplays();
    updatePreview();
    updatePurchaseSummary();
    updateProgress();
    updateAtcState();
    updateStickyBar();
  }

  function updateQtyDisplays() {
    if (qtyDisplay.chain)    qtyDisplay.chain.textContent    = state.chains;
    if (qtyDisplay.ring)     qtyDisplay.ring.textContent     = state.rings;
    if (qtyDisplay.bracelet) qtyDisplay.bracelet.textContent = state.bracelets;

    // Enable/disable minus buttons
    minusBtns.forEach((btn) => {
      const piece = btn.dataset.piece;
      const count = state[piece + 's'] ?? 0; // chains, rings, bracelets
      btn.disabled = count <= 0;
    });

    // Disable plus buttons if total would exceed 9
    plusBtns.forEach((btn) => {
      btn.disabled = total() >= 9;
    });
  }

  function updatePreview() {
    const t = total();
    const ppp = state.pricePerPiece;

    if (elCountChains)    elCountChains.textContent    = state.chains + '× Chain';
    if (elPriceChains)    elPriceChains.textContent    = state.chains > 0 ? '$' + (state.chains * ppp) : '—';
    if (elCountRings)     elCountRings.textContent     = state.rings + '× Ring';
    if (elPriceRings)     elPriceRings.textContent     = state.rings > 0 ? '$' + (state.rings * ppp) : '—';
    if (elCountBracelets) elCountBracelets.textContent = state.bracelets + '× Bracelet';
    if (elPriceBracelets) elPriceBracelets.textContent = state.bracelets > 0 ? '$' + (state.bracelets * ppp) : '—';
    if (elTotalFinal)     elTotalFinal.textContent     = '$' + (t * ppp);

    if (elPreviewMinNote) {
      if (t === 0) {
        elPreviewMinNote.textContent = 'Add at least 2 pieces to build your set.';
      } else if (t === 1) {
        elPreviewMinNote.textContent = 'Add 1 more piece to unlock your set.';
      } else if (t === 9) {
        elPreviewMinNote.textContent = 'Maximum 9 pieces reached.';
      } else {
        elPreviewMinNote.textContent = '';
      }
    }
  }

  function updateProgress() {
    if (!progressFill) return;
    const pct = Math.min(total() / 9 * 100, 100);
    progressFill.style.width = pct + '%';
  }

  function updatePurchaseSummary() {
    const t = total();
    const ppp = state.pricePerPiece;

    if (selStyle)     selStyle.textContent     = state.aestheticName || '—';
    if (selMetal)     selMetal.textContent     = state.metal ? capitalize(state.metal) : '—';
    if (selChains)    selChains.textContent    = state.chains > 0 ? state.chains + ' × $' + ppp : '—';
    if (selRings)     selRings.textContent     = state.rings > 0 ? state.rings + ' × $' + ppp : '—';
    if (selBracelets) selBracelets.textContent = state.bracelets > 0 ? state.bracelets + ' × $' + ppp : '—';

    // Ring size row: show only when rings > 0
    if (selSizeRow) selSizeRow.style.display = state.rings > 0 ? 'flex' : 'none';
    if (selSize)    selSize.textContent      = state.ringSize || '—';

    if (purchasePrice) purchasePrice.textContent = '$' + (t * ppp);
    if (purchasePriceSub) {
      if (t === 0) {
        purchasePriceSub.textContent = 'Select your pieces above';
      } else {
        purchasePriceSub.textContent = t + ' piece' + (t !== 1 ? 's' : '') + ' · $' + ppp + ' each';
      }
    }
  }

  /* ── Set text on all .bl-atc-btn elements (inline + sticky) ── */
  function setAtcText(text) {
    $$('.bl-atc-btn').forEach((btn) => {
      const textEl = btn.querySelector('.bl-atc-btn__text');
      if (textEl) textEl.textContent = text;
      else btn.textContent = text;
    });
  }

  function updateAtcState() {
    if (!atcBtn) return;

    const t    = total();
    const ppp  = state.pricePerPiece;
    const needsSize = state.rings > 0 && !state.ringSize;
    const ready = state.aesthetic && state.metal && t >= 2 && !needsSize;

    atcBtn.disabled = !ready;
    atcBtn.setAttribute('aria-disabled', String(!ready));
    if (stickyBtn) stickyBtn.disabled = !ready;

    let label;
    if (!state.aesthetic) {
      label = 'Start Building';
    } else if (!state.metal) {
      label = 'Select your metal above';
    } else if (t === 0) {
      label = 'Choose your pieces above';
    } else if (t < 2) {
      const need = 2 - t;
      label = 'Add ' + need + ' more piece' + (need !== 1 ? 's' : '') + ' to complete';
    } else if (needsSize) {
      label = 'Select your ring size above';
    } else {
      label = 'Get My ' + (state.aestheticName || '') + ' Set — $' + (t * ppp);
    }
    setAtcText(label);

    // Cross-sell dynamic — activate once gate is met
    const crosssellDynamic = $('.bl-crosssell__dynamic');
    if (crosssellDynamic) {
      if (ready && state.aestheticName) {
        crosssellDynamic.textContent =
          'Complete your ' + state.aestheticName + ' look. The Signature — chain, ring, bracelet, built for the same aesthetic. $60. ' +
          'Or the ' + state.aestheticName + ' Ring Edit — 5 rings, curated to match. $80.';
        crosssellDynamic.style.display = '';
      } else {
        crosssellDynamic.style.display = 'none';
      }
    }

    // Sync form hidden inputs
    if (inputQuantity)  inputQuantity.value  = t || 1;
    if (inputAesthetic) inputAesthetic.value = state.aesthetic || '';
    if (inputMetal)     inputMetal.value     = state.metal || '';
    if (inputChains)    inputChains.value    = state.chains;
    if (inputRings)     inputRings.value     = state.rings;
    if (inputBracelets) inputBracelets.value = state.bracelets;
    if (inputSize)      inputSize.value      = state.ringSize || '';
  }

  function updateStickyBar() {
    if (!stickyBar) return;

    const t     = total();
    const ppp   = state.pricePerPiece;
    const ready = !!(state.aesthetic && state.metal && t >= 2 && !(state.rings > 0 && !state.ringSize));

    // Price: "from $40" until pieces are added, then live total
    if (stickyPrice) {
      stickyPrice.textContent = t > 0 ? '$' + (t * ppp) : 'from $40';
    }

    // Combined label: "The Selects — from $40" or "The Selects — $XX · Aesthetic"
    if (stickyLabel) {
      if (ready && state.aestheticName) {
        stickyLabel.textContent = 'The Selects — $' + (t * ppp) + ' · ' + state.aestheticName;
      } else {
        stickyLabel.textContent = 'The Selects — from $40';
      }
    }
    // stickyBtn.disabled is managed by updateAtcState() which mirrors both buttons
  }

  /* ── Ring size section visibility ─────────────────── */
  function syncRingSizeSection() {
    if (!ringSizeSection) return;
    if (state.rings > 0) {
      ringSizeSection.hidden = false;
      // Smooth scroll to ring size if just unlocked
    } else {
      ringSizeSection.hidden = true;
      state.ringSize = null;
      // Reset ring size buttons
      $$('.bl-ring-size-btn').forEach((btn) => btn.setAttribute('aria-checked', 'false'));
    }
  }

  /* ── Capitalize helper ─────────────────────────────── */
  function capitalize(str) {
    return str ? str.charAt(0).toUpperCase() + str.slice(1) : str;
  }

  /* ── Style tile clicks ─────────────────────────────── */
  $$('.bl-style-tile').forEach((tile) => {
    tile.addEventListener('click', () => {
      // Deselect all
      $$('.bl-style-tile').forEach((t) => t.setAttribute('aria-checked', 'false'));
      tile.setAttribute('aria-checked', 'true');

      state.aesthetic     = tile.dataset.style;
      state.aestheticName = tile.dataset.styleName;

      // Prefill quantities
      const pChains    = parseInt(tile.dataset.chains, 10)    || 0;
      const pRings     = parseInt(tile.dataset.rings, 10)     || 0;
      const pBracelets = parseInt(tile.dataset.bracelets, 10) || 0;

      state.chains    = pChains;
      state.rings     = pRings;
      state.bracelets = pBracelets;

      if (elStyleConfirm) {
        elStyleConfirm.textContent = tile.dataset.styleName + ' selected — choose your metal below.';
      }

      syncRingSizeSection();
      render();

      // Auto-scroll to metal selector
      setTimeout(() => {
        const metalSection = document.getElementById('bl-metal');
        if (metalSection) metalSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 320);
    });
  });

  /* ── Quantity buttons ──────────────────────────────── */
  minusBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const piece = btn.dataset.piece; // "chain" | "ring" | "bracelet"
      const key   = piece + 's';       // "chains" | "rings" | "bracelets"
      if (state[key] > 0) {
        state[key]--;
        if (piece === 'ring') syncRingSizeSection();
        render();
      }
    });
  });

  plusBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (total() >= 9) return;
      const piece = btn.dataset.piece;
      const key   = piece + 's';
      state[key]++;
      if (piece === 'ring') syncRingSizeSection();
      render();
    });
  });

  /* ── Metal tile clicks ─────────────────────────────── */
  $$('.bl-metal-tile').forEach((tile) => {
    tile.addEventListener('click', () => {
      $$('.bl-metal-tile').forEach((t) => t.setAttribute('aria-checked', 'false'));
      tile.setAttribute('aria-checked', 'true');
      state.metal = tile.dataset.metal;
      if (elMetalConfirm) {
        elMetalConfirm.textContent = capitalize(state.metal) + ' selected.';
      }
      render();

      // Auto-scroll to quantity builder
      setTimeout(() => {
        const buildSection = document.getElementById('bl-build');
        if (buildSection) buildSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 320);
    });
  });

  /* ── Ring size button clicks ───────────────────────── */
  $$('.bl-ring-size-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      $$('.bl-ring-size-btn').forEach((b) => b.setAttribute('aria-checked', 'false'));
      btn.setAttribute('aria-checked', 'true');
      state.ringSize = btn.dataset.size;
      render();
    });
  });

  /* ── Cart AJAX submit ──────────────────────────────── */
  if (addForm) {
    addForm.addEventListener('submit', (e) => {
      e.preventDefault();

      const t = total();
      if (!state.aesthetic || !state.metal || t < 2) return;
      if (state.rings > 0 && !state.ringSize) return;

      const formData = new FormData(addForm);
      const payload  = {};
      formData.forEach((val, key) => { payload[key] = val; });

      setAtcText('Adding…');
      atcBtn.disabled = true;
      if (stickyBtn) stickyBtn.disabled = true;

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body:    JSON.stringify(payload),
      })
        .then((res) => {
          if (!res.ok) throw new Error('Cart error');
          return res.json();
        })
        .then(() => {
          // Try to open cart drawer
          const drawerTrigger = document.querySelector('[data-cart-drawer-trigger], .cart-drawer-trigger, [href="/cart"]');
          if (window.Shopify && typeof window.Shopify.onCartUpdate === 'function') {
            window.Shopify.onCartUpdate();
          }
          // Dispatch custom event for theme cart drawers
          document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

          setAtcText('✓ Added to Cart');
          setTimeout(() => {
            atcBtn.disabled = false;
            if (stickyBtn) stickyBtn.disabled = false;
            updateAtcState();
          }, 2400);
        })
        .catch(() => {
          // Fallback to native form submit
          addForm.submit();
        });
    });
  }

  /* ── Sticky bar: show/hide via IntersectionObserver ── */
  if (stickyBar) {
    const hero = $('#bl-hero');
    if (hero) {
      const obs = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) {
            stickyBar.classList.add('bl-sticky--visible');
            stickyBar.setAttribute('aria-hidden', 'false');
          } else {
            stickyBar.classList.remove('bl-sticky--visible');
            stickyBar.setAttribute('aria-hidden', 'true');
          }
        },
        { threshold: 0.1 }
      );
      obs.observe(hero);
    }
  }

  /* ── Scroll reveal ─────────────────────────────────── */
  const revealObs = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('bl-reveal--visible');
          revealObs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );
  $$('.bl-reveal').forEach((el) => revealObs.observe(el));

  /* ── Initial render ────────────────────────────────── */
  render();
})();
